import { render, staticRenderFns } from "./BrandDetails.vue?vue&type=template&id=ab0f07b8&scoped=true&"
import script from "./BrandDetails.vue?vue&type=script&lang=ts&"
export * from "./BrandDetails.vue?vue&type=script&lang=ts&"
import style0 from "./BrandDetails.vue?vue&type=style&index=0&id=ab0f07b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0f07b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab0f07b8')) {
      api.createRecord('ab0f07b8', component.options)
    } else {
      api.reload('ab0f07b8', component.options)
    }
    module.hot.accept("./BrandDetails.vue?vue&type=template&id=ab0f07b8&scoped=true&", function () {
      api.rerender('ab0f07b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/BrandDetails.vue"
export default component.exports